import { stageBarStatesOf, type StageBar, type StageBarKey } from '@nest-recruit/shared';

/**
 * A move drawn on JOB-12's bar before the server recounts it (CLAUDE.md §5a rule 1): `count`
 * people leave one stage and arrive in another, and the current stage follows (§L33). A stage the
 * bar doesn't draw leaves it as it is — the server's recount is the truth either way.
 */
export function shiftStageBar(bar: StageBar, from: StageBarKey, to: StageBarKey, count: number): StageBar {
  const source = bar.stages.find((stage) => stage.key === from);
  const target = bar.stages.find((stage) => stage.key === to);
  if (!source || !target || source.count === null || target.count === null) return bar;
  const moving = Math.min(count, source.count);
  if (moving <= 0) return bar;

  const counted = bar.stages.map((stage) => {
    if (stage.key === from && stage.count !== null) return { ...stage, count: stage.count - moving };
    if (stage.key === to && stage.count !== null) return { ...stage, count: stage.count + moving };
    return stage;
  });
  // ① Job carries no count: it is occupied only while it is the draft's current stage.
  const states = stageBarStatesOf(counted.map((stage) => ({ key: stage.key, occupied: stage.count === null ? stage.state === 'current' : stage.count > 0 })));
  return { ...bar, stages: counted.map((stage, index) => ({ ...stage, state: states[index] ?? stage.state })) };
}
